import { Button, buttonVariant } from '../Button'
import { focus } from '../../helpers'
import { StyleFn } from '..'

export const Rating: StyleFn = (theme) => {
  const { size } = theme
  const { focusWithPseudo } = focus(theme)
  const { root: rootButtonStyles } = Button(theme)

  return {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
    },
    _small: {
      '& $item': {
        minWidth: size.spacing[24],
        minHeight: size.spacing[24],
        '&:not(:last-child)': {
          marginRight: 2,
        },
        '& $icon': {
          width: size.spacing[24],
          height: size.spacing[24],
          fontSize: size.spacing[24],
        },
      },
    },
    _readonly: {
      pointerEvents: 'none',
    },
    item: {
      extend: [rootButtonStyles, buttonVariant(theme, 'ghost'), focusWithPseudo()],
      minWidth: size.spacing[40],
      minHeight: size.spacing[40],
      padding: 0,
      position: 'relative',
      '&:not(:last-child)': {
        marginRight: size.spacing[8],
      },
      '&:active': {
        backgroundColor: 'unset',
      },
      "&[aria-pressed='true']": {
        backgroundColor: 'unset',
      },
      '&:hover': {
        backgroundColor: 'unset',
        '& $icon$icon_full': { display: 'inline-flex' },
      },
    },
    item_half: {
      '& $icon$icon_half': { display: 'inline-flex' },
    },
    item_full: {
      '& $icon$icon_full': { display: 'inline-flex' },
    },
    icon: {
      position: 'absolute',
      top: -2,
      boxSizing: 'border-box',
      // increase specificity to override
      // button "& > i, & > svg" selectors
      '$icon&': {
        margin: 0,
        width: size.spacing[40],
        height: size.spacing[40],
        fontSize: size.spacing[40],
      },
      '&$icon_half, &$icon_full': { display: 'none' },
    },
    icon_half: {},
    icon_full: {},
  }
}
